import {
    SAVE_ADDRESS_PROOF,
    SAVE_ADDRESS_PROOF_FRONT_SIDE,
    SAVE_ADDRESS_PROOF_BACK_SIDE,
    RESET_ADDRESS_PROOF
} from './actions';

export const initialState = {
    addressProof: '',
    addressProofFrontSide: '',
    addressProofBackSide: ''
};

const addressProofReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_ADDRESS_PROOF:
            return {
                ...state,
                addressProof: action.addressProof
            }
        case SAVE_ADDRESS_PROOF_FRONT_SIDE:
            return {
                ...state,
                addressProofFrontSide: action.addressProofFrontSide
            }
        case SAVE_ADDRESS_PROOF_BACK_SIDE:
            return {
                ...state,
                addressProofBackSide: action.addressProofBackSide
            }
        case RESET_ADDRESS_PROOF:
            return {
                ...state,
                ...initialState
            }
        default: return state
    }
}

export default addressProofReducer;